// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__WcsEX","social":"Footer_social__suz1P","footerSpan":"Footer_footerSpan__RY1o-","social1":"Footer_social1__qjSCx","iconFooter":"Footer_iconFooter__vHs7O"};